export const KEY_NAMES = {
  enter: 'Enter',
  escape: 'Escape',
  space: ' ',
};
